module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/font/glyphicons-halflings-regular.woff
// module id = eSx+
// module chunks = 0